import { render, staticRenderFns } from "./storepurchase.vue?vue&type=template&id=2ffaedd8&scoped=true&"
import script from "./storepurchase.vue?vue&type=script&lang=js&"
export * from "./storepurchase.vue?vue&type=script&lang=js&"
import style0 from "./storepurchase.vue?vue&type=style&index=0&id=2ffaedd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffaedd8",
  null
  
)

export default component.exports